var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelationship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.4995,
    y: 14,
    width: 4.00002,
    height: 1.00001,
    transform: "rotate(-180 14.4995 14)",
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4995,
    y: 8,
    width: 4.00002,
    height: 1.00001,
    transform: "rotate(-180 14.4995 8)",
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4995,
    y: 13,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 10.4995 13)",
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4995,
    y: 13,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 10.4995 13)",
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49902,
    y: 14,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 9.49902 14)",
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49951,
    y: 15,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 8.49951 15)",
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 16,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 7.5 16)",
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    y: 15,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 6.49951 15)",
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49951,
    y: 17,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 8.49951 17)",
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49902,
    y: 18,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 9.49902 18)",
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.49951,
    y: 14,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 5.49951 14)",
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    y: 17,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 6.49951 17)",
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.49951,
    y: 18,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 5.49951 18)",
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4995,
    y: 9,
    width: 1.00001,
    height: 1.00001,
    transform: "rotate(-180 10.4995 9)",
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49902,
    y: 11.9998,
    width: 1.00001,
    height: 3.00002,
    transform: "rotate(-180 9.49902 11.9998)",
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 1.00001,
    transform: "matrix(1 0 0 -1 14.4995 13)",
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 1.00001,
    transform: "matrix(1 0 0 -1 14.4995 9)",
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 3.00002,
    transform: "matrix(1 0 0 -1 15.4995 11.9998)",
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 2.49951,
    y: 3,
    width: 4.00002,
    height: 1.00001,
    fill: "#232323"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 2.49951,
    y: 9,
    width: 4.00002,
    height: 1.00001,
    fill: "#232323"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    y: 4,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    y: 4,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 7.49951,
    y: 3,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 8.49902,
    y: 2,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49902,
    y: 1,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4995,
    width: 1.00001,
    height: 5.00003,
    fill: "#232323"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    width: 4.00002,
    height: 1.00001,
    fill: "#232323"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 6.49951,
    y: 8.00024,
    width: 1.00001,
    height: 1.00001,
    fill: "#232323"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 7.49951,
    y: 5,
    width: 1.00001,
    height: 3.00002,
    fill: "#232323"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 1.00001,
    transform: "matrix(-1 0 0 1 2.49951 4)",
    fill: "#232323"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 1.00001,
    transform: "matrix(-1 0 0 1 2.49951 8.00024)",
    fill: "#232323"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 1.00001,
    height: 3.00002,
    transform: "matrix(-1 0 0 1 1.49951 5)",
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.cab8700e3e1b4c229207023bc566c390.svg";
export { ForwardRef as ReactComponent };